import {Component, OnInit} from '@angular/core';

import {Router} from '@angular/router';
import {AuthService} from '../../auth/auth.service';
import {GetService} from '../../core/get.service';
import {AppMemoryService} from '../../core/app-memory.service';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-locate-unauth',
    templateUrl: './locate-unauth.component.html',
    styleUrls: ['./locate-unauth.component.less']
})
export class LocateUnauthComponent implements OnInit {

    public availableCountries = [];

    constructor(public router: Router,
                public appMemory: AppMemoryService,
                public authService: AuthService,
                public getService: GetService) {

        if (this.authService.isLocated) {
            this.router.navigateByUrl('/login');
        }
    }

    ngOnInit() {
        Object.keys(environment.availableCountries).forEach(country => {
            this.availableCountries.push({
                country: country,
            })
        });
    }

    public chooseCountry(choose) {
        localStorage.setItem('isLocated', 'true');
        window.location.href = environment.availableCountries[choose] + '/login';
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/locate-unauth/locate-unauth.component.ts